import { OrderStatus, ErrorCode } from '@triplabo/web/services/types';

export default {
  views: {
    dashboard: {
      title: 'Dashboard'
    },
    home: {
      title: 'GO×Triplabo Taxi',
      greeting: "Hi, let's go!",
      go: 'Provided by GO',
      loginButton: 'Login Now',
      destinationPlaceholder: 'Where are you going?',
      pickUp: 'Pick Up',
      recommendPickup: 'Recommended Pickup Points',
      recommendDropOff: 'Recommended Drop-off Points',
      cannotUsePoint: 'No Pickup/Drop-off Zone',
      nowPlace: 'Current Location',
      nowPlaceJa: '現在地',
      categories: {
        recommend: 'Recommended',
        transportation: 'Transportation',
        attraction: 'Attractions',
        experience: 'Experiences'
      },
      viewDetail: 'View Details',
      status: {
        finding: {
          title: 'Calling for vehicles',
          subtitle: 'Please wait patiently'
        },
        dispatching: {
          subtitle: 'Driver will arrive soon'
        },
        pickUpArrived: {
          subtitle: 'Driver has arrived, please contact soon'
        },
        onDeliver: {
          subtitle: 'Vehicle is on the way'
        }
      }
    },
    pickup: {
      title: 'Select Pickup Point',
      searchPlaceholder: 'Please enter pickup location',
      recommendTitle: 'Recommended nearby pickup points',
      historyTitle: 'History',
      empty: 'No data available',
      emptyTip:
        'Try different keywords, or use "Map Selection" to place order immediately',
      emptyButton: 'Map Selection',
      deleteConfirm: 'Confirm deletion?',
      deleteConfirmRecall: 'Confirm',
      deleteConfirmCancel: 'Cancel',
      facilityTag: 'Recommend'
    },
    pointChange: {
      searchUpPlaceholder: 'Please enter pickup location',
      searchDownPlaceholder: 'Please enter drop-off location',
      title: 'Change Pickup Point',
      titleDropOff: 'Change Drop-off Point',
      description: 'Drag the map pin to change pickup location',
      descriptionDropOff: 'Drag the map pin to change drop-off location',
      confirm: 'Confirm Pickup Point',
      confirmDropOff: 'Confirm Drop-off Point'
    },
    dropOff: {
      title: 'Select Drop off Point',
      searchPlaceholder: 'Please enter drop off location',
      recommendTitle: 'Recommended nearby drop off points'
    },
    orderConfirm: {
      discountApplied: 'Discounted',
      paymentTimeoutDialog: {
        description:
          'System is busy, please contact customer service for refund',
        subtitle:
          'Please take a screenshot first, then contact customer service for refund',
        goToService: 'customer service',
        orderIdLabel: 'Order ID'
      },
      paymentProcessing: 'Order confirmation in progress, please do not close',
      ascfPayConfirm: {
        content: 'Payment confirmed?',
        confirm: 'OK',
        notPaid:
          'Payment not confirmed, please check order status in "My Trips"'
      },
      title: 'Call a taxi now, get on faster!',
      selectType: 'Select Vehicle Type',
      normal: 'Economy Taxi',
      premium: 'Premium Taxi',
      wagon: 'Comfort Taxi',
      airport: 'Airport Fixed',
      airportTag: 'Fixed Fare',
      airportTip:
        'Fixed amount in JPY. Actual amount will be settled at the average exchange rate on the day of payment.',
      confirm: 'Call Now',
      time: 'Approximately {{min}}-{{max}} minutes to pickup',
      estimate: 'Estimate',
      estimateTag: 'Estimated Fare',
      discount: 'Discount',
      unit: '¥',
      coupon: 'Coupon',
      couponAvailable: '{{count}} cp available',
      checkOrderFailed: 'Failed to check order status, please try again later',
      callWaiting: {
        title: 'No vehicles nearby currently, continue calling?',
        subtitle:
          'We will continue searching for available vehicles and notify you immediately when found',
        confirm: 'Continue Calling',
        cancel: 'Cancel Call',
        finding: 'Searching for nearby vehicles...',
        dispatching: 'Dispatching vehicles, please wait patiently',
        continueWaiting: 'No vehicles nearby, continue waiting?',
        continue: 'Continue Waiting',
        unwait: 'Stop Waiting'
      }
    },
    profile: {
      title: 'My Profile',
      order: 'My Trips',
      coupon: 'Coupons',
      service: 'Customer Service Center',
      userName: 'Username',
      editProfile: 'Edit Profile',
      notLogin: 'Not Logged In',
      goToLogin: 'Login with Account',
      logout: 'Logout',
      creditCard: 'Credit Card'
    },
    editUserInfo: {
      title: 'Edit Personal Information',
      name: 'Name (Pinyin)',
      email: 'Contact Email (for electronic receipts)',
      phone: 'Contact Phone',
      confirm: 'Confirm Changes',
      emailError: 'Please enter a valid email address',
      phoneError: 'Please enter a valid phone number',
      nameError: 'Please enter a valid name',
      success: 'Changes successful',
      error: 'Changes failed, please try again later'
    },
    order: {
      all: 'All',
      succeed: 'Completed',
      pending: 'Unpaid',
      canceled: 'Canceled',
      empty: 'No orders',
      emptyTip: 'Go call a taxi',
      noMore: 'No more',
      orderId: 'Order ID',
      carType: {
        normal: 'Economy',
        premium: 'Premium',
        wagon: 'Comfort',
        airport: 'Airport Fixed',
        any: 'Economy'
      },
      status: {
        [OrderStatus.Succeed]: 'Completed',
        [OrderStatus.Canceled]: 'Canceled',
        [OrderStatus.Finding]: 'Calling',
        [OrderStatus.DispatchFailed]: 'Calling',
        [OrderStatus.Dispatching]: 'In Transit',
        [OrderStatus.PickUpArrived]: 'In Transit',
        [OrderStatus.OnDeliver]: 'In Transit',
        [OrderStatus.DropOff]: 'Completed',
        pending: 'Unpaid'
      },
      money: '{{amount}}'
    },
    payment: {
      title: 'Prepay Fare...',
      description:
        'To ensure smooth dispatch, please pay the estimated fare in advance. After the trip, any difference will be settled.',
      wechat: 'WeChat Pay',
      wechatDesc: 'Pay in RMB, suitable for mainland WeChat users',
      agreement: 'I have carefully read and agree to',
      agreementLink: '《Prepayment Agreement》',
      confirm: 'Prepay ¥{{amount}}',
      money: '¥{{amount}}',
      support: 'Support'
    },
    cancelOrder: {
      success: 'Order canceled',
      confirmCancel: {
        title: 'Confirm Cancel Order',
        warning:
          'When you cancel an order, cancellation fees may apply. Please confirm if you want to cancel the order?',
        note: 'To maintain a good taxi ecosystem, frequent cancellations may result in order restrictions. Thank you for your support and understanding!',
        viewRules: 'View Cancellation Rules',
        waitMore: 'Wait a bit more',
        confirm: 'Cancel Order',
        cancelFee: 'Cancellation Fee',
        cancelFeeDescription: '¥{{amount}}'
      },
      selectReason: {
        title: 'Select Cancellation Reason',
        submit: 'Confirm Submit',
        otherReason: 'Other Reason',
        customReasonPlaceholder:
          'If there are other reasons, please tell us here',
        reasons: {
          platform: {
            title: 'Platform Related',
            content: {
              tooFar: 'Platform dispatch too far',
              inaccurateLocation:
                'Inaccurate location/cannot find pickup location',
              notExpectedCar: 'Not the vehicle type I expected'
            }
          },
          driver: {
            title: 'Driver Related',
            content: {
              driverNotComing:
                'Driver not coming to pick me up (car not moving/getting further away)',
              driverNotContactable: 'Cannot contact/find driver',
              driverCancel: 'Driver requested order cancellation',
              driverLate: 'Driver late',
              driverNotMatch: 'Not the vehicle or driver shown in order'
            }
          },
          self: {
            title: 'Personal Reasons',
            content: {
              selfChange: 'My plans changed, no need for taxi now',
              otherPlatform: 'Got a taxi on another platform',
              cannotArrive: 'Cannot arrive at pickup location on time'
            }
          }
        }
      }
    },
    fareEstimate: {
      title: 'Fare Estimate',
      unit: 'JPY',
      hero: {
        title: 'About Fare Estimate',
        subtitle: 'Fast response, quick pickup, great value'
      },
      fee: {
        title: 'Fare Breakdown Estimate',
        totalLabel: 'Estimated total',
        approx: 'Est.',
        range: '{{min}}~{{max}}',
        items: {
          transport: 'Transport fee (incl. fees)',
          carTypeFee: 'Vehicle type fee',
          pickup: 'Pickup fee',
          dispatch: 'Dispatch fee (incl. long-distance)',
          service: 'Platform service fee',
          regional: 'Regional development fee',
          peak: 'Peak adjustment',
          etc: 'Toll fees (incl. ETC, etc.)',
          coupon: 'Coupon discount'
        },
        notes: {
          estimate:
            'The estimate is calculated based on actual traffic conditions, expected distance, time, exchange rate fluctuations and other factors. It may vary and is for reference only.',
          service:
            'The platform service fee is calculated in tiers based on the actual distance traveled.',
          extra:
            'Additional charges such as highway tolls and bridge fees incurred during the trip are not included in the estimate. The final amount is based on the actual settlement after the trip ends.'
        }
      },
      faq: {
        title: 'FAQ',
        q: 'Q',
        a: 'A',
        items: {
          why: {
            question: 'Why is the actual fare higher than the estimate?',
            answer:
              'The fare shown before booking is only an estimate. If the actual fare exceeds it, the difference may be caused by traffic congestion, extra stops during the trip, additional charges (such as tolls), and other factors.'
          },
          extraFee: {
            question: 'Are additional fees paid by the passenger?',
            answer:
              'Additional fees incurred during the trip, such as highway tolls, bridge fees and parking fees, are borne by the passenger according to actual usage.'
          },
          routeChange: {
            question: 'Does a route change affect the fare?',
            answer:
              'If the route changes during the trip due to traffic conditions or passenger requests, the final fare will be settled based on the actual distance and time.'
          },
          cancelFee: {
            question: 'Will canceling an order incur a cancellation fee?',
            answer:
              'If you cancel after the free cancellation window has passed or after the driver has arrived at the pickup point, a cancellation fee will apply per the platform rules.'
          }
        }
      }
    },
    orderDetail: {
      empty: 'No data available',
      serviceProvider: 'Service provided by GO Inc.',
      more: {
        title: 'More',
        orderId: 'Order ID:{{orderId}}'
      },
      finding: {
        title: 'Calling for vehicles...',
        estimatedTime:
          'Expected to be answered within {{time}} minutes, waited',
        cancelButton: 'Cancel Order'
      },
      remaining: 'Remaining',
      minutes: 'minutes',
      meter: 'meters',
      kilometers: 'km',
      canceled: {
        title: 'Order canceled',
        subtitle: 'If needed, you can call for a taxi again',
        provider: 'Service provided by GO Inc.',
        customerService: 'Service',
        paymentDetail: 'Details',
        recallButton: 'Call Taxi Again',
        backHome: 'Back to home page'
      },
      succeed: {
        title: 'Trip completed',
        provider: 'Service provided by GO Inc.',
        actualPay: 'Actual Payment',
        unit: '¥',
        customerService: 'Service',
        getInvoice: 'Receipt',
        drivingFee: 'Trip Fee Amount',
        additionalPaymentAmount: 'Additional Payment Amount',
        prepaid: 'Settlement in Progress',
        discount: 'Discount Amount'
      },
      getInvoice: {
        title: 'Issue Electronic Receipt',
        description:
          'Electronic receipt will be sent to your email as an attachment',
        invoiceTitle: 'Invoice Title',
        invoiceTitlePlaceholder: 'Please enter invoice title',
        email: 'Email Address',
        emailPlaceholder: 'Please enter email address',
        emailError: 'Please enter a valid email address',
        remark: 'Remarks',
        remarkPlaceholder: 'Please enter remarks',
        submit: 'Submit',
        success: 'Electronic receipt sent to your email',
        error: 'Receipt sending failed, please try again later'
      },
      confirmDialog: {
        noDriver: 'No nearby drivers found, would you like to call again?',
        recall: 'Call Again',
        cancel: 'Cancel Order',
        driverCancel:
          'Driver canceled the order. This order has been canceled and refund will be automatically processed, arriving in your wallet shortly.',
        driverCancelConfirm: 'I understand'
      },
      rideCode: {
        title: 'Ride Code',
        description: 'Please show the driver the following ride code',
        waitingNumber: 'Meeting Number',
        destination: 'Destination'
      },
      receive: {
        cardTitle: 'After boarding, please show the driver your ride code',
        viewCode: 'View Ride Code',
        dispatchingText: 'Driver has accepted the dispatch',
        dispatchingDescription: 'Driver is heading to pickup location',
        pickUpArrivedText: 'Driver has arrived',
        pickUpArrivedDescription: 'Please contact the driver soon to board',
        onDeliverText: 'Heading to destination',
        onDeliverDescription: 'Trip has started, please fasten your seatbelt',
        message: 'Send Message',
        cancelOrder: 'Cancel Order',
        shareTrip: 'Share Trip'
      }
    },
    repay: {
      statusText: 'Order pending payment',
      serviceProvider: 'Service provided by GO Inc.',
      service: 'Contact Customer Service',
      paidText: 'Additional Payment',
      unit: '¥',
      feeUnit: '{{amount}}',
      repayment: 'Additional Fare Payment',
      drivingFee: 'Trip Fee Amount',
      prepaidAmount: 'Prepaid Amount'
    },
    repayDetail: {
      title: 'Prepayment Details',
      prepaymentAmount: 'Prepaid Amount',
      actualUsage: 'Actual usage after trip completion',
      unusedPrepayment: 'Unused Prepayment',
      finishedRefund:
        'Order completed, unused prepayment refunded to original payment method',
      unusedPrepaymentRefund:
        'Order canceled, unused prepayment refunded to original payment method',
      paymentReminder:
        'Additional fare payment required, please return to payment',
      additionalFarePaid: 'Order completed, additional fare has been paid',
      cancelFee: 'Cancellation Fee',
      insufficientPrepaymentNotice:
        'When the prepayment is insufficient to cover the actual fare for your trip, you need to pay the shortfall, otherwise you will not be able to continue using the travel service.',
      bankProcessingNote:
        'Actual transfer time depends on bank processing time. If not received within 7 business days, please contact customer service',
      cancelFeeNote:
        'After successful vehicle dispatch, cancellation fees apply if the order is canceled due to passenger reasons.',
      cny: '元',
      unit: 'JPY'
    },
    chat: {
      tips: {
        templateOnly: 'Only template messages below are supported',
        translation:
          "Driver-passenger messages will be automatically translated into the other party's familiar language."
      }
    },
    hotelHome: {
      title: 'Taxi Travel',
      wechatScan: {
        title: 'WeChat Scan',
        description:
          'Scan QR code with phone to enter WeChat mini program, view more products'
      }
    },
    hotelDropOff: {
      title: 'Select Drop-off Point'
    },
    hotelOrderConfirm: {
      title: 'Confirm Order',
      unit: 'JPY',
      modify: 'Modify'
    },
    hotelPayment: {
      title: 'Prepay Fare',
      description:
        'Please use your phone to scan the QR code below for payment',
      money: '<span>JPY</span>{{amount}}',
      alertText:
        'To ensure smooth dispatch, please pay the estimated fare. After the trip, any difference will be settled. Unused prepayment will be refunded to the original payment method.'
    },
    hotelPrePayTerms: {
      title: 'Prepayment Agreement',
      headDesc: `Given that you have registered as a user of the "GOx Japan Taxi" platform (hereinafter referred to as "our company") and according to platform rules, you may need to prepay fees when using our travel services, this prepayment agreement (hereinafter referred to as "this agreement") is hereby established.
Please carefully read the content of this agreement and use this service after fully understanding and agreeing. Minors should read and agree to this agreement with their legal guardians. By clicking "Agree" or using this service, you are deemed to have read, understood, and accepted all content of this agreement, and are willing to fulfill relevant obligations and bear corresponding responsibilities.`,
      content: [
        {
          title: 'Prepayment Payment Rules',
          content: [
            "For your convenience in using taxi services, we provide prepayment methods. Before the trip begins, you need to prepay the fare according to the platform's estimated cost.",
            'The prepayment amount will be estimated based on your selected or reserved travel needs and according to the pricing rules publicly displayed on the platform. This prepayment will be used to offset corresponding fees after you actually use the service.',
            'After you confirm the trip and pay the prepayment, the order becomes officially effective. If you do not pay the prepayment, you will not be able to submit the order or use driver services within our platform.'
          ]
        },
        {
          title: 'Prepayment Settlement and Adjustment',
          content: [
            'Prepayment is only used for taxi order payments and does not constitute a recharge.',
            'After the order is effective and the trip is completed, the system will settle according to actual costs, following the principle of "refund excess, collect shortfall".',
            'If the prepayment exceeds the actual cost, the platform will refund the balance to the original payment path after trip completion. The specific refund time depends on the processing time of banks or third-party payment institutions.',
            'If the prepayment is insufficient to pay the actual cost, you need to make up the difference. You can continue using platform services only after completing the payment.'
          ]
        },
        {
          title: 'Order Cancellation and Refund',
          content: [
            'After paying the prepayment and generating an order, if the trip cannot be completed due to reasons not attributable to you (including but not limited to order not being accepted, force majeure events, etc.), the platform will fully refund the prepayment, with the refund path being the same as the payment path.',
            'If you actively cancel after the order is generated and are determined to be "responsible for cancellation", the platform will deduct fees according to the corresponding pricing rules and refund the remaining amount.',
            'Refund time limits depend on the processing time of banks or third-party payment institutions, usually not exceeding 7 business days. If refund issues arise, you can contact platform customer service, and we will assist in communicating with payment institutions for processing.'
          ]
        },
        {
          title: 'Legal Application and Dispute Resolution',
          content: [
            'This agreement is part of the "GOx Japan Taxi User Agreement", and matters not covered herein are subject to the user agreement. This agreement, together with the user agreement, privacy policy, and other documents, constitutes the legal basis for this service. If there are conflicts between this agreement and other related documents, this agreement shall prevail.',
            'This agreement is governed by Japanese law. If disputes arise from this agreement, both parties should resolve them through friendly negotiation; if negotiation fails, they may be submitted to a court with jurisdiction for adjudication.'
          ]
        },
        {
          title: 'Other Terms',
          content: [
            'If any provision of this agreement is determined to be illegal, invalid, or unenforceable at any time, but does not affect the overall effectiveness of the agreement, other provisions remain valid. We reserve the right to reasonably adjust relevant provisions to make them comply with applicable laws.',
            'We reserve the final right of interpretation of this agreement and may revise the agreement content from time to time according to business needs. The revised agreement will be publicly displayed on the platform, and continued use of the service by users is deemed acceptance of the revised agreement.'
          ]
        }
      ]
    },
    hotelPayResult: {
      success: {
        title: 'Payment Successful',
        description: 'Redirecting'
      },
      fail: {
        title: 'Payment Failed',
        subtitle: 'Please try placing the order again',
        description:
          'Please check if your network, bank card balance, etc. are normal',
        btnText: 'Return to Taxi Page',
        seconds: '{{amount}}s'
      }
    },
    hotelOrderDetail: {
      requestSuccess: 'Call a taxi successfully'
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated: March 18, 2022',
      company: 'LINKTIVITY Corporation',
      contentTitle: 'Personal Information Protection Policy',
      subTitle:
        "Our company collects users' personal information through LINKTIVITY, a reservation website operated by our company. Our company believes that protecting users' personal information is very important to allow users to book products with peace of mind and convenience, so our company handles personal information by complying with the following provisions:",
      content: [
        {
          title: 'Manager of User Personal Information',
          content:
            'LINKTIVITY Corporation\n〒100-0011 19F, Hibiya Park Front, 2-1-6 Uchisaiwai-cho, Chiyoda-ku, Tokyo'
        },
        {
          title: 'Information Collection',
          content:
            "Except in cases required by law, our company collects the minimum necessary personal information from users after obtaining their consent to achieve our company's usage purposes."
        },
        {
          title: 'Information Usage',
          content:
            'Our company only uses personal information collected from users when achieving the usage purposes stipulated by our company.'
        },
        {
          title: 'Storage and Preservation',
          content:
            'Our company performs storage and preservation work on personal information to ensure that personal information obtained from users does not leak, and ensures system security.'
        },
        {
          title: 'Destruction and Deletion',
          content:
            'When personal data (referring to personal information stipulated by the Personal Information Protection Law, the same applies hereinafter) is no longer needed for use, our company will destroy it promptly.'
        },
        {
          title: 'User Consultation and Other Processing',
          content:
            'For user requests to inform usage purposes, disclosure requests, correction/addition/deletion requests, stop usage/deletion requests, and stop provision to third parties, our company will process them according to legal requirements.'
        },
        {
          title: 'Security Management Measures and Others',
          content:
            'Our company will educate all employees related to LINKTIVITY services to understand the importance of personal information and take necessary and appropriate measures to manage the security of personal information.'
        }
      ],
      rules: [
        {
          title:
            '1. Personal Information Obtained by Our Company and Its Usage Purposes',
          subtitle:
            "Our company will collect and use users' personal information such as address, name, date of birth, contact information, email address, or passport number for the following purposes. Additionally, without user consent, our company will not collect personal information that requires special attention. When collecting personal information from users, if the personal information usage purpose is not publicly disclosed, the personal information usage purpose should be informed to users or publicly displayed. Furthermore, without parental consent, our company will not collect personal information from children under 13 years old. When our company collects personal information from children under 13 years old, it will be deemed that guardian consent has been obtained, but if there is clearly no consent, our company will not use that personal information for purposes other than contacting guardians.",
          rule: [
            {
              title:
                'i. LINKTIVITY Service Usage (Member Registration, etc.) Purpose',
              content:
                'To use LINKTIVITY services, our company will share user personal information within the company.\nLegal basis: Necessary to provide services or functions requested by users.'
            },
            {
              title: 'ii. Ticket Purchase Application',
              list: [
                {
                  title: 'Personal Information Collection Items',
                  content:
                    "When users apply to product suppliers to purchase tickets, our company will collect users' names, payment information, passport numbers, and information related to users' health conditions, etc."
                },
                {
                  title: 'Specific Usage Purposes',
                  content:
                    "Our company will collect users' personal information to confirm users' ticket purchase eligibility and payment matters. Additionally, to achieve this purpose, our company will provide users' personal information to product suppliers, transportation agencies, payment settlement providers (including overseas providers, etc.), etc."
                }
              ],
              subtitle:
                "Legal basis: To meet users' service needs and provide necessary functions."
            },
            {
              title:
                'iii. To send notifications to users, including newsletters (email magazines, etc.), our company will collect personal information after user consent',
              content:
                'Legal basis: Information collection based on user consent.'
            },
            {
              title:
                'iv. Advertising delivery through social media and advertising platforms',
              content:
                'Legal basis: Information collection based on user consent.'
            },
            {
              title: 'v. To request questionnaire completion',
              content:
                "Legal basis: Collecting personal information based on user consent to improve our company's reservation website, products, services, and other content."
            },
            {
              title: 'vi. To analyze and manage user information',
              content:
                "Legal basis: To pursue and protect users' legitimate interests by improving our company's reservation website, products, services, and other content."
            },
            {
              title: 'vii. To detect unauthorized use of credit cards, etc.',
              content:
                "Legal basis: Necessary to ensure the security of users' credit cards to pursue and protect users' legitimate interests."
            }
          ]
        },
        {
          title: '2. Third-Party Provision of Personal Information',
          subtitle:
            "Our company will not provide users' personal information obtained to third parties, except in the following cases:\n\ni. When users provide personal information to third parties (including product suppliers, overseas travel agencies, social media operators, advertising service companies, and other businesses). When users have previously agreed to provide personal information to third parties through consent to this privacy policy or other means.\nii. When entrusting external organizations to process personal information within the necessary scope.\niii. When providing personal information is required by law.\niv. When it is necessary to protect an individual's life, body, or property and user consent cannot be obtained.\nv. When it is particularly necessary to improve public health or promote healthy child development and user consent cannot be obtained.\nvi. When cooperating with national and local governments to execute legal affairs, and obtaining user consent may affect the execution of those affairs.",
          rule: []
        },
        {
          title: '3. Entrustment of Personal Information Processing',
          subtitle:
            "When the company, in necessary cases, entrusts users' personal information to third parties based on the above provisions, it will provide necessary and appropriate supervision to the entrusted party to achieve the company's purposes. If the entrusted party re-entrusts, the company will directly or indirectly supervise whether the entrusted party provides necessary and appropriate supervision to the re-entrusted party. The same applies to cases of re-re-entrustment.\nIf our company, according to the above provisions, entrusts users' personal information to third parties within the necessary scope to achieve our company's usage purposes, our company will provide necessary and appropriate supervision to the entrusted party. Additionally, if the entrusted party re-entrusts data, our company will directly or indirectly supervise whether the entrusted party provides necessary and appropriate supervision to the re-entrusted party. The same should apply to cases where the re-entrusted party re-entrusts.",
          rule: []
        },
        {
          title: '4. Obtaining Cookie Information, etc.',
          rule: [
            {
              title: 'i. Cookies',
              content:
                "Cookies are pieces of data stored on users' hard drives containing information about users. Our company does not use cookies as personal identification information. Additionally, since they are temporary cookies, once users close their browsers, cookies will not be saved. Our company uses cookies to improve service quality, customize our company's website, and measure advertising effectiveness.\nAdditionally, our company analyzes cookies as statistical data to detect users' interests and concerns and prevent unauthorized access.\nUsers can disable cookies according to their needs, but this will prevent users from making reservations on LINKTIVITY."
            },
            {
              title: 'ii. Logs/Files',
              content:
                'Our company automatically collects specific information and saves it in log files. This specific information includes IP (Internet Protocol) addresses, browser types, ISP (Internet Service Provider), referrer/exit pages, operating systems, date/time stamps, etc. Our company uses this information to monitor unauthorized access. Additionally, our company conducts user trend analysis, website management, and user behavior tracking.\nHowever, when using the above information, our company ensures that specific individuals are not identified and that the obtained information is not used for any purposes other than those mentioned above.'
            },
            {
              title: 'iii. Web Beacons',
              content:
                'Our company uses Web Beacons for access analysis and affiliate programs. Our company will not use Web Beacons for any purposes other than those mentioned above, nor will they be used to identify specific individuals.'
            },
            {
              title: 'iv. Statistical Analysis',
              content:
                "Our company uses third-party access analysis tools to confirm which websites and services are popular and record users' access pages and page history within the LINKTIVITY website.\nOur company uses this data to provide LINKTIVITY content and advertisements that match the interests of users interested in specific areas.\nAdditionally, our company may collect statistical information unrelated to personal identity. Furthermore, cookie information collected by our company and cookie information collected by other companies may be mutually viewed on third-party access analysis tools."
            }
          ]
        },
        {
          title: '5. Processing of Anonymized Information',
          rule: [
            {
              title: '1. Creation of Anonymized Information Processing:',
              content:
                'Our company will comply with the following provisions when creating anonymized information. Anonymized information processing refers to personal information-related information obtained by processing personal information, taking legally stipulated measures that cannot identify specific individuals and cannot restore the original personal information.\n\n1) Follow legally stipulated standards and perform appropriate processing;\n2) Take security measures according to legally stipulated standards to prevent leakage of deleted information or information processing methods;\n3) Publicly disclose information items that have been processed into anonymized information;\n4) Take no action to perform personal identification behavior.'
            },
            {
              title: '2. Provision of Anonymized Information',
              content:
                'If anonymized information is to be provided to third parties, our company should publicly disclose the personal information-related items in the anonymized information to be provided and the provision method, and clearly inform the third party receiving the information that it is anonymized information.'
            },
            {
              title: '3. Regarding Disclosure of Anonymized Information',
              content:
                'Regarding the creation of anonymized information\nFor the following users\' personal information, our company will continuously create anonymized information while taking appropriate measures to ensure that specific individuals cannot be identified and personal information cannot be restored.\n\nPersonal information-related items contained in anonymized information\nInformation obtained for providing platform services\nPurchase date, participation date, coupon language, sales price range, number of participants, reservation status (confirmed reservation or cancellation, etc.), supplier location area and prefecture information, travel agency country/region\n\nProvision of anonymized information to third parties\nFor anonymized information created or held by our company, our company will continuously provide it to third parties after clearly indicating that it is anonymized information.\n\nPersonal information-related items contained in anonymized information\nSame items as "Personal information-related items contained in anonymized information" in "Regarding the creation of anonymized information" above\n\nProvision method\nSend password-protected electronic files through electronic communication methods (email, server upload, API links, etc.) or physical media such as DVDs.'
            }
          ]
        },
        {
          title: '6. Security Management Measures for Personal Information',
          subtitle:
            'To prevent personal information leakage, theft, misuse, unauthorized access, tampering, and destruction, our company has implemented organizational, technical, and physical security management measures. Access to servers storing personal information by our company is limited to specific employees holding ID/PW, and particularly for certain personal information management, only the minimum number of employees required for data management are allowed access.\n\nAdditionally, personal information including credit card information is distributed across multiple data centers and stored in secure environments. We also use Secure Socket Layer (SSL) encryption on all reservation transaction pages. By using SSL-enabled browsers, you can keep personal information and credit card information transmitted over the Internet confidential.\n\nAdditionally, employees handling user personal information will use password-protected screen savers when leaving terminals.\n\nFurthermore, our company conducts education and training on the importance of personal information and other matters once a month for some departments and at least once every six months for the entire company, and retains education records.',
          rule: []
        },
        {
          title: '7. Rights Regarding User Personal Information Processing',
          subtitle:
            'According to the EU General Data Protection Regulation (GDPR) 2016/679 effective from April 27, 2016, regarding the processing of personal information, users have the following rights:',
          rule: [
            {
              title: 'i. Right of Access'
            },
            {
              title: 'ii. Right of Rectification'
            },
            {
              title:
                'iii. Right to Erasure (Right to be Forgotten) and Right to Restrict Processing'
            },
            {
              title: 'iv. Right to Data Portability'
            },
            {
              title: 'v. Right to Object'
            },
            {
              title:
                'vi. Right not to be Subject to Decisions Based on Automated Processing (Including Profiling).'
            }
          ]
        },
        {
          title:
            '8. Requests for Disclosure, Correction, Cessation of Use, etc.',
          subtitle:
            'Our company will respond to the following requests through the contact window listed in Article 11 below: usage purposes provided by users, disclosure requests, correction/addition/deletion requests, cessation of use, deletion requests, and suspension of provision to third parties of retained personal information (hereinafter collectively referred to as "disclosure requests, etc.").\n\nAdditionally, our company may also change and confirm member information on users\' personal pages and stop services such as email magazines according to user requests.',
          rule: []
        },
        {
          title: '9. External Links',
          subtitle:
            'The LINKTIVITY website contains links to other websites. This privacy policy only applies to information collected by the LINKTIVITY website, and our company bears no responsibility for the privacy policies or content of other websites. When users visit other linked websites, it is recommended to read their privacy policies and confirm how they handle personal information.',
          rule: []
        },
        {
          title: '10. Changes to Privacy Policy',
          subtitle:
            'Our company publishes the privacy policy on the LINKTIVITY website to enable users to know the purposes for which our company obtains and uses user personal information and what information our company collects. Additionally, if the privacy policy changes, it will also be published on the LINKTIVITY website to make it public to users.',
          rule: []
        },
        {
          title: '11. Contact Information',
          subtitle:
            "If you have questions about our company's privacy policy, personal information protection measures, collection and use of personal information, or requests for disclosure, etc., please contact us using the information below, and our company staff will respond within 5 business days.\n\nLINKTIVITY Corporation\n〒100-0011 19F, Hibiya Park Front, 2-1-6 Uchisaiwai-cho, Chiyoda-ku, Tokyo\n\nData Protection Officer Contact: dpo@linktivity.co.jp",
          rule: []
        },
        {
          title:
            '* This is a translated version, the original text shall prevail.',
          rule: []
        }
      ]
    },
    terms: {
      name: 'Terms of Use',
      title: 'LINKTIVITY Terms of Use',
      lastUpdated: 'Last Updated: May 1, 2020',
      subtitle: `LINKTIVITY Terms of Use
LINKTIVITY Corporation (hereinafter referred to as "our company") has established the following LINKTIVITY Terms of Use (hereinafter referred to as "this agreement") for the use of LINKTIVITY services.

By using LINKTIVITY services, you acknowledge that you have agreed to accept the contents of this agreement. Please read this agreement carefully when using LINKTIVITY services. Additionally, this agreement may be modified as needed, so please refer to the latest content when using LINKTIVITY services.

* For information regarding the handling of personal information, please read the "Personal Information Protection Policy."`,
      content: [
        {
          title: 'Article 1 Purpose',
          content:
            'This agreement applies to users of the services of "LINKTIVITY," a platform sales website for venue rentals operated by our company. Users of this service must agree to this agreement in advance and use this service based on compliance with this agreement. This agreement may also be modified without prior notice.'
        },
        {
          title: 'Article 2 Member Registration',
          content: `1. "Member" refers to an individual who has been approved by our company to become a member. Such individual, upon agreeing to this agreement, accepting and completing the member registration procedures specified by our company, obtains this service according to these terms. However, even after approval, if our company deems the member inappropriate, approval may be revoked.
2. Information provided during member registration should be true, accurate, and valid. Individual, registration information (such as name, email address, etc.), and passwords should correspond one-to-one, and the same person should not register multiple member identities.
3. If registration information changes, members must immediately perform the prescribed change procedures.`
        },
        {
          title: 'Article 3 Information Provided by Product Suppliers',
          content:
            'Our company provides members with content, fees, available purchase dates, cancellation provisions (cancellation policies), and other purchase-related information (hereinafter referred to as "purchase-related information") provided by product suppliers on LINKTIVITY, as well as product supplier-related information. Purchase-related information is the responsibility of product suppliers, and unless our company fails to transmit information due to intentional acts or negligence, our company bears no responsibility for the content of purchase-related information.'
        },
        {
          title: 'Article 4 Contract Formation',
          content:
            'On the LINKTIVITY platform, contracts related to products purchased and services provided by members will be concluded between members and product suppliers. Posting products, services, and other content on LINKTIVITY is only for the purpose of submitting applications to product suppliers, and our company has the right to freely approve or reject such applications on behalf of product suppliers. This agreement stipulates the conditions for members to use LINKTIVITY services, including cases where members submit purchase applications to product suppliers using LINKTIVITY. However, member reservations for products and services must follow the contract conditions displayed by LINKTIVITY, information provided during the reservation process, and conditions stipulated by legal contracts related to products and services as stipulated by product suppliers.'
        },
        {
          title: 'Article 5 Fee Payment',
          content: `LINKTIVITY, as a collection agent for product suppliers, obtains payment information from members and processes payments. Members should pay fees to our company through credit cards or payment methods provided by our company when purchasing products and services. If expressed in foreign currency, our company will convert the credit card payment amount or settlement amount of payment methods provided by our company to yen according to the determined exchange rate.

However, some payments should be made through one or more methods specified on the page.`
        },
        {
          title:
            'Article 6 Content and Quality of Products and Services Provided by Product Suppliers',
          content:
            'Our company is not responsible for the content and quality of products and services provided by product suppliers. Any problems, disputes, or complaints arising between members and product suppliers, as well as any losses suffered by members, should be resolved through consultation with product suppliers, and our company bears no responsibility for this.'
        },
        {
          title: 'Article 7 Usage Environment',
          content: `1. When using LINKTIVITY, members should prepare necessary communication equipment, software, communication means, and other products and services on their own, and bear full responsibility and costs incurred during the period.
2. When using LINKTIVITY, members should prepare necessary smartphones, software, communication means, and other products and services that can connect to the network on their own, and bear full responsibility and costs incurred during the period.`
        },
        {
          title:
            'Article 8 Order Cancellation and Cancellation Fees Due to Member Reasons',
          content: `1. Cancellation fees incurred when members cancel orders due to their own reasons will be charged according to the cancellation terms (cancellation policies) stipulated by product suppliers.
2. Our company bears no responsibility for foreign exchange gains and losses caused during payment and refund.
3. In principle, members need to log into the "Personal Page" of LINKTIVITY and cancel reservations. However, if they contact product suppliers before the usage date and product suppliers accept order cancellation, cancellation procedures can be completed by notifying LINKTIVITY through the "Personal Page" later.`
        },
        {
          title:
            'Article 9 Order Cancellation and Refunds Due to Product Suppliers',
          content:
            'When product suppliers change or cancel products and services, they should directly notify members, and our company bears no responsibility for changes or cancellations of products and services. However, according to decisions or requirements of product suppliers, if the content of sold products or services changes or is cancelled, our company may handle refunds for products or services on their behalf.'
        },
        {
          title: 'Article 10 Password Management',
          content: `1. Members are responsible for and should manage passwords.
2. Members should not provide email addresses and passwords to third parties for use, and should not lend, transfer, rename, sell, mortgage, etc.
3. Damage liability caused by improper password management, usage errors, or third-party usage by members is borne by members themselves, and our company bears no responsibility.`
        },
        {
          title: 'Article 11 Handling of Member Registration Information',
          content: `1. During member registration, personal information provided by members (hereinafter referred to as "registration information") will be managed and stored by our company according to our company's personal information protection policy.
2. Our company will not disclose to third parties information containing personally identifiable information (hereinafter referred to as "personal information"). However, the following cases are excluded:

   i. When disclosing information with customer consent

   ii. When providing personal information necessary for service performance to business outsourcing companies that have signed personal information protection confidentiality agreements

   iii. When conducting statistical analysis of personal information for service improvement and disclosing or providing to third parties in a state where personal identity cannot be identified or determined

   iv. When disclosure is required according to search warrants issued by courts or court judgments

Additionally, please read the "Personal Information Protection Policy" to understand the personal information obtained by our company, usage purposes, and processing details.`
        },
        {
          title: 'Article 12 Prohibited Items for Members',
          content: `When using LINKTIVITY, members should not engage in the following behaviors or behaviors that may lead to the following:

1. Behaviors that violate this agreement
2. Behaviors that violate public order and morals or laws and regulations
3. Behaviors that infringe on copyrights, portrait rights, or other intellectual property rights of our company, other members, or third parties
4. Behaviors that defame or slander other members or third parties
5. Behaviors that bring adverse effects to other members or third parties
6. Behaviors that interfere with our company's business or hinder our company's service operations
7. Profit-making behaviors
8. Behaviors of transferring or lending rights obtained as members to third parties without prior consent of our company
9. Other behaviors that our company deems inappropriate`
        },
        {
          title:
            'Article 13 Deletion or Correction of Information Sent by Members',
          content: `Our company may delete part or all of the information sent by members that conforms to or may belong to any of the following items, or make any corrections that our company deems necessary, without member consent:

1. Information that our company deems to conform to the "Member Prohibited Items" of this agreement
2. Information that our company judges to be inconsistent with facts
3. Other situations that our company deems inappropriate`
        },
        {
          title: 'Article 14 Cancellation of Member Status',
          content: `If members fall under any of the following situations, our company may cancel member status without prior notice to members, and bears no responsibility to members:

1. One of the situations that violate the "Member Prohibited Items" of this agreement
2. Other violations of this agreement
3. Other situations where our company deems the member unsuitable for member status`
        },
        {
          title: 'Article 15 Service Changes, Suspension, and Termination',
          content: `1. Our company may change, suspend, or terminate service content without prior notice to members.
2. When any disadvantages or losses are caused to members due to changes, suspension, or termination of this service content, our company bears no responsibility.
3. Our company may notify members one month in advance and terminate service provision.`
        },
        {
          title: 'Article 16 Copyright and Property Rights',
          content:
            'All content displayed on LINKTIVITY is copyrighted and owned by our company and individuals or entities such as product suppliers, partners, and advertisers who provide such content to our company. Unless prior written consent is obtained from our company, product suppliers, partners, and advertisers, users and members agree not to copy, disclose, transfer, lend, translate, reprint, transmit, use, or reuse such content. Additionally, our company has the right to claim compensation from users and members for amounts equivalent to benefits obtained during the above-mentioned behaviors.'
        },
        {
          title: 'Article 17 Disclaimer and Liability Limitation',
          content: `1. Our company bears no responsibility for any damages occurring between our company and product suppliers, any damages caused by members violating this agreement, or damages caused by non-company reasons during product or service exchange processes.
2. Product suppliers are independent contract entities from our company. Our company bears no responsibility for any damages or other damages caused by injuries, deaths, property losses, theft, or terrorist attacks when members participate in product activities or enjoy services due to behaviors, negligence, omissions, agency behaviors, guarantees, etc. of product suppliers.
3. Our company bears no responsibility for events such as delays, cancellations, duplicate purchases, strikes, etc. of products or services beyond our company's direct management scope. Additionally, when content changes, cancellations, delays, additional costs, etc. occur due to government agencies, court orders, etc., our company bears no response obligations.
4. When our company provides this service, if members directly or indirectly suffer losses beyond actual, ordinary losses, even if our company has intentional or negligent acts, our company bears no responsibility.`
        },
        {
          title: 'Article 18 Changes to This Agreement',
          content:
            'Our company reserves the right to change the content of this agreement when necessary. When modifying this agreement, changes are considered completed by simply making modifications on this page, and members will not be notified individually.'
        },
        {
          title: 'Article 19 Jurisdiction',
          content:
            'For any disputes regarding this agreement, the Tokyo District Court will be the exclusive court of first instance.'
        },
        {
          title: 'Article 20 Consultation',
          content:
            'For matters not stipulated in this agreement or any questions about this agreement, both parties should negotiate in good faith and make friendly efforts to find solutions together.'
        },
        {
          title:
            '* This is a translated version, the original text shall prevail.',
          content: ''
        }
      ]
    },
    login: {
      title: 'Sign In / Sign Up',
      content: {
        title: 'Please select a method to login/register as a member',
        description:
          '*Can easily login and register as a member using a third-party account',
        agreement:
          '*When you login using your email or a third-party account, it will be deemed that you have agreed to the relevant <terms>{{terms}}</terms> and <privacy>{{privacy}}</privacy>',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy'
      },
      button: {
        google: 'Google',
        email: 'Email',
        nextStep: 'Next Step',
        signIn: 'Sign In'
      },
      email: {
        label: 'Email'
      }
    },
    couponList: {
      title: 'Coupon Wallet',
      tabs: {
        inputCode: 'Input Coupon Code',
        shareCoupon: 'Share Coupon Code'
      },
      inputPlaceholder: 'Please enter coupon code',
      condition: 'Available when total estimated fare exceeds JPY{{amount}}',
      applyTo: 'Applicable to premium taxi',
      validUntil: 'Valid until',
      minSpend: 'Available for JPY{{amount}} or more',
      maxDiscount: 'Max discount JPY{{amount}}',
      noMinSpend: 'No minimum spend',
      useButton: 'Use Now',
      validDate: 'Valid from {{start}} to {{end}}',
      empty: 'No coupons available',
      emptyTip: 'Go claim some coupons',
      couponType: {
        NEW_USER: 'New User Discount Coupon',
        SHARE: 'Share Coupon',
        SHARE_REWARD: 'Share Reward Coupon',
        BUNDLE: 'Bundle Coupon',
        PROMOTION: 'Limited Time Coupons',
        AIRPORT_COUPON: 'Airport Fixed Discount Coupon',
        UNKNOWN_COUPON_TYPE: 'Unknown Coupon'
      }
    },
    showDialog: {
      title: 'Share Your Code & Get Rewards!',
      description:
        'For friend invite coupons, click "View Wallet" and redeem invites for <span>high-value coupons</span>',
      rideButton: 'Ride Now',
      shareButton: 'Share Invite Code'
    },
    shareCoupon: {
      title: 'Share Invite Code',
      headline: 'Invite friends to enjoy ride discounts together!',
      description:
        'Invite friends to successfully register, friends can get a 9.5-fold discount coupon (up to 500 JPY), and after completing their first ride, you can get a 200 JPY coupon (valid for 7 days), unlimited invitations',
      description2:
        'After your friend enters your exclusive invite code, your friend gets a <span>2000 JPY off coupon</span>, and once your friend takes a ride you get a <span>1000 JPY off coupon</span>! Automatically issued to your coupon wallet, valid for 15 days after claiming. Invite as many friends as you like, and GO together!',
      campaignDate:
        '(This campaign runs until October 12, 2026, limited to the first 2000 claims)',
      linkLabel: 'Invitation Link',
      inviteCodeLabel: 'Exclusive Invite Code',
      copyButton: 'Copy',
      copySuccess: 'Copied successfully',
      copyFailed: 'Copy failed'
    },
    redeemCoupon: {
      title: 'Enter Coupon Code',
      codeLabel: 'Coupon Code',
      placeholder: 'Please enter coupon code',
      confirmButton: 'Confirm Redemption',
      instruction1:
        '*Enter the coupon redemption code, click [Confirm Redemption] to complete the redemption;',
      instruction2:
        '*Each redemption code can only be successfully redeemed once. After successful redemption, please use it within the validity period, otherwise it will be void.',
      emptyCode: 'Please enter coupon code',
      redeemSuccess: 'Redemption successful',
      redeemFailed: 'Redemption failed, please try again later'
    },
    getCoupon: {
      title: 'Claim Coupon',
      coupon: {
        title: 'New User Discount Coupon',
        validity: 'Valid until {{validity}}',
        discount: '{{value}}%<unit>discount</unit>',
        minimumSpend: 'Available for JPY{{amount}} or more',
        usageCondition:
          'Available when total estimated fare exceeds JPY{{amount}}'
      },
      button: {
        claim: 'Claim Now'
      },
      terms: {
        itema:
          '*Available for users who registered for the first time and have not yet taken a ride',
        itemb:
          '*Requires login to claim; expired or not logged in cannot claim; only one claim opportunity per scan',
        itemc:
          '*After successful claim, you can enter "My Coupon Pack" to view and use',
        itemd: '*Limited to 7 days of use, expires afterward'
      },
      success: {
        title: 'Claim Successful',
        description:
          'The coupon has been successfully added to your coupon wallet. You can go to my coupon wallet to view and use it.',
        viewButton: 'View Coupon',
        gotItButton: 'I Got It'
      },
      newComer: {
        title: 'Congratulations on your rewards!',
        description:
          'For invite coupons, tap "View Wallet" to share your code or redeem a coupon code.',
        rideButton: 'Ride Now',
        viewButton: 'View Wallet',
        coupon: {
          discountUnit: '{{value}}%<unit>OFF</unit>',
          jpyUnit: '<unit>JPY</unit>{{value}}',
          maxDiscount: 'Up to JPY{{amount}} off',
          validity: 'Valid until {{validity}}'
        }
      }
    },
    signIn: {
      register: 'Sign Up',
      login: 'Sign In',
      email: {
        label: 'Email'
      },
      password: {
        label: 'Password'
      },
      button: {
        register: 'Sign Up',
        signIn: 'Sign In'
      },
      forgetPassword: 'Forgot Password?',
      validate: {
        email: {
          invalid: 'Please enter a valid email'
        },
        password: {
          required: 'Please enter a password'
        }
      }
    },
    reset: {
      title: 'Reset Password',
      email: {
        label: 'Email'
      },
      button: {
        reset: 'Send Email to Reset Password',
        backToSignIn: 'Back to Sign In'
      },
      sendResetEmailSuccess:
        'A password reset link has been sent to <email>{{email}}</email> Please check your email and reset your password.'
    },
    service: {
      title: 'Customer Service Center',
      categories: {
        fee: 'Fee Related',
        driver: 'Driver Related',
        other: 'Other Issues'
      },
      items: {
        fee: {
          estimatedCost: {
            label: 'Estimated Cost',
            content:
              'Estimated cost helps you understand the approximate trip expenses. After entering your pickup and drop-off locations, you can see the estimated cost on the next page. Estimated cost is calculated based on the shortest route and estimated travel time. Actual charges may vary due to factors such as traffic, weather, road construction, or different routes. Please note: Estimated cost is only valid when placing an order. Additional fees such as tolls or airport fees are not included in the estimated cost. This quote is only an estimate, and we cannot guarantee that the actual trip charge will not exceed the estimated cost.'
          },
          costBreakdown: {
            label: 'Cost Breakdown',
            content:
              'Your trip cost is calculated based on various factors and may vary by region and ride-hailing provider. When calculating prices, providers mainly consider the following three factors: 1. Base fare 2. Distance fee (trip distance) 3. Time fee (trip duration) Other factors that may affect actual costs: 1. Dynamic pricing, such as "peak time pricing" 2. Tolls and airport fees 3. Vehicle category 4. Mini-program service fee If actual charges differ from your expected costs, please refer to the answer about "actual charges higher than estimated costs". Please note: Cost breakdown is not currently available on electronic receipts. At the end of the trip, we will send you the actual cost calculated by the ride-hailing provider. When you use the mini-program, you are deemed to accept the prices displayed on the mini-program and the deducted fees are the actual charges for the trip. Actual charges may differ from the price on the taxi meter.'
          },
          additionalFees: {
            label: 'Highway fees, airport fees and other additional fees',
            content:
              'Please note that airport fees, highway fees, tolls, and other additional fees are not included in the estimated cost; all these additional fees must be borne by passengers. However, drivers may add these fees to the actual fare before the trip ends.'
          },
          cancellationFees: {
            label: 'Order cancellation fees',
            content:
              'To compensate drivers for empty travel distance and time, if you cancel an order under the following two circumstances, you may need to pay order cancellation fees: 1. The driver has accepted the order and has been driving toward your pickup location for a certain amount of time or distance. 2. The driver has arrived at the pickup location and waited for more than a certain amount of time. In this case, even if the driver cancels the order, you still need to pay order cancellation fees. Charging order cancellation fees helps ride-hailing providers maintain efficient operations and ensure faster vehicle dispatch. Please note that order cancellation fees may vary by location and ride-hailing provider. If you think the charges are unreasonable, please contact our customer service team through the "Contact Customer Service" button, and we will do our best to help you resolve the issue.'
          },
          actualCostHigher: {
            label: 'Actual cost higher than estimated cost',
            content:
              'The quote before you place an order is only an estimated cost, and we cannot guarantee that the actual trip charge will not exceed the estimated cost. If actual charges are higher than estimated costs, it may be due to the following reasons: 1. Traffic congestion 2. Additional charges, such as tolls or airport fees 3. Additional stops during the trip 4. Driver chose a different route 5. Navigation or network issues If you have any questions about actual charges, please contact our customer service team through the "Contact Customer Service" button, and we will do our best to assist you in resolving the issue.'
          },
          vehicleDamage: {
            label: 'Vehicle damage and cleaning fees',
            content:
              'If passengers dirty the vehicle, they need to bear cleaning fees. When the above situation occurs, drivers have the right to add cleaning fees to the actual charges. This part of the fee will be paid directly to drivers for vehicle cleaning. Please do not eat or drink in the car, and help maintain the cleanliness of the vehicle.'
          }
        },
        driver: {
          longerRoute: {
            label: 'Driver chose a longer driving route',
            content:
              'Drivers have the right to choose the fastest or shortest route according to navigation recommendations. If at the end of the trip, actual charges exceed estimated costs, it may be because the driver chose a longer driving route (to avoid traffic congestion or certain road emergencies). If you have a preferred route, please communicate with the driver before departure and reach an agreement to avoid any misunderstandings. If actual charges are significantly higher than expected, please contact our customer service team through the "Contact Customer Service" button, and we will do our best to assist you in resolving the issue.'
          },
          orderNotEnded: {
            label: 'Driver did not end the order after getting off',
            content:
              'Drivers should end the order immediately when you get off or shortly after. If actual charges are significantly higher than estimated costs due to the driver not ending the order in time, please contact our customer service team through the "Contact Customer Service" button, and we will do our best to assist you in resolving the issue.'
          }
        },
        other: {
          lostItems: {
            label: 'Lost items',
            content:
              'We understand your urgency about lost items, and we will do our best to help you find them. Please click the "Contact Customer Service" button below to communicate with our customer service team for verification, and please provide the following information: 1. Please describe the item you lost in detail 2. If the item has been found, where would you like to retrieve it? 3. Please leave your phone number so we can contact you promptly after helping you find the item 4. How long will you stay in this location? After receiving the above information, we will contact the ride-hailing provider as soon as possible and do our best to help you find the lost item. Please note: Due to privacy protection laws, we cannot provide you with driver contact information. Please note: We will do our best to help you find lost items, but we cannot take any responsibility for items lost during the trip.'
          },
          otherIssues: {
            label: 'Other issues',
            content:
              'If you have other questions or suggestions about orders or our services, please contact our customer service team through the "Contact Customer Service" button below, and we will do our best to assist you in resolving the issue.'
          }
        }
      },
      contact: 'Contact Customer Service'
    }
  },
  cancelTerms: {
    title: 'Cancellation Rules',
    textTitle: 'GOx Japan Taxi Cancellation Rules',
    content: [
      {
        title: 'Cancellation Fee Description',
        content: [
          'When a driver accepts an order for more than 3 minutes or has already arrived at the pickup point, if you cancel the order, the supplier may charge a cancellation fee.',
          'Due to potential differences in cancellation fee rules among different suppliers, please refer to the information provided by the supplier for specific fee standards.'
        ]
      },
      {
        title: 'Purpose of Cancellation Fees',
        content: [
          'The cancellation fees collected by the platform will be used to compensate drivers for the empty driving costs caused by trip cancellations, to protect driver rights.'
        ]
      },
      {
        title: 'When You Need to Pay Cancellation Fees',
        content: [
          'If you cancel an order after the specified time, causing the driver to incur empty driving costs, you need to pay a cancellation fee as compensation.',
          'Specific cancellation fee standards will be calculated according to supplier rules, and the system will display the corresponding fees when canceling.'
        ]
      },
      {
        title: "When You Don't Need to Pay Cancellation Fees",
        content: [
          "When canceling an order within the specified time, you don't need to pay a cancellation fee.",
          {
            title:
              'If you cancel an order for the following reasons, cancellation fees may be waived:',
            content: [
              'Driver actively cancels the order',
              "Driver doesn't arrive at the pickup point at the scheduled time",
              "Driver refuses to pick up passengers or doesn't come without reason",
              'Other situations where the order cannot proceed normally due to driver reasons'
            ]
          },
          'If cancellation fees are generated due to the above situations, you can contact customer service to appeal, and the platform will process the cancellation fee waiver after verification.'
        ]
      },
      {
        title: 'Dispute Resolution',
        content: [
          'If you have objections to cancellation fees, you can contact customer service to appeal within 24 hours after the order is cancelled.',
          'The platform will verify based on order records, driver feedback, and related evidence, and make a final decision after verification is completed.'
        ]
      }
    ],
    bottomDesc:
      'Thank you for choosing the GOx Japan Taxi platform, have a pleasant journey!'
  },
  components: {
    confirm: {
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    map: {
      locationPermission: {
        harmony: 'Unable to get your location. Go to Settings > Privacy & security > Location, turn on location services, and allow this service to access your location.',
        wechat: 'Unable to get your location. Go to Settings on your phone, turn on location services, and allow WeChat to access your location.',
        ios: 'Unable to get your location. Go to Settings > Privacy & Security > Location Services, turn on Location Services, and allow your browser to access your location.',
        android: 'Unable to get your location. Go to Settings > Location to turn on location services, then allow this site to access your location in the site settings of your browser.',
        default: 'Unable to get your location. Please allow this site to access your location in your browser settings.'
      },
      locationPermissionConfirm: 'Got it'
    },
    hotel: {
      back: 'Back',
      multiLanguage: 'EN/中/日/한'
    }
  },
  common: {
    noData: 'No data available',
    copyright: '© LINKTIVITY Inc. All Rights Reserved.'
  },
  errorCode: {
    [ErrorCode.Internal]: 'System is busy, please try again later',
    [ErrorCode.Unauthorized]: 'Login has expired, please login again',
    [ErrorCode.InvalidArgument]:
      'Input information is incorrect, please re-enter',
    [ErrorCode.PaymentFailed]: 'Payment failed, please try again',
    [ErrorCode.PendingPaymentExist]:
      'You have an incomplete payment order, please handle it first',
    [ErrorCode.PaymentNotCompleted]:
      'Payment not completed, please continue payment',
    [ErrorCode.LoginFailed]: 'Login failed, please try again',
    [ErrorCode.RefundFailed]: 'Refund failed, please contact customer service',
    [ErrorCode.AccessTokenExpired]: 'Login has expired, please login again',
    [ErrorCode.TaxiNotFound]: 'No available vehicles, please try again later',
    [ErrorCode.InvalidLocation]:
      'Invalid location information, please reselect',
    [ErrorCode.NotCancellable]: 'Current order status cannot be canceled',
    [ErrorCode.DeadlineExceeded]: 'System is busy, please try again later',
    [ErrorCode.CouponNotFound]: 'Coupon not found',
    [ErrorCode.CouponExpired]: 'Coupon has expired',
    [ErrorCode.CouponAlreadyUsed]: 'Coupon has already been used',
    [ErrorCode.CouponNotApplicable]: 'Coupon is not applicable',
    [ErrorCode.CouponAlreadyRedeemed]:
      'You have already redeemed this type of coupon',
    [ErrorCode.CouponOutOfAllotment]: 'Coupon is out of allotment',
    [ErrorCode.CouponEventEnded]: 'Coupon event has ended',
    [ErrorCode.CouponEventNotStarted]: 'Coupon event has not started yet'
  },
  firebase: {
    'auth/wrong-password': 'Login name or password is incorrect',
    'auth/user-not-found': 'Login name or password is incorrect',
    'auth/email-already-in-use': 'Email already exists',
    'auth/too-many-requests':
      'Login attempt limit exceeded. Please try again later, or reset your password.'
  }
};
